{
  "sourceTitle": "New Volunteering Team",
  "sourceDescription": "Group volunteers into teams to organize their roles, invites, and training.",
  "volunteeringIcon": "Volunteering",
  "unavailable": "Unavailable creation methods may require you to connect an external provider in <link>Connections</link>",
  "createInSalt": "Create in Salt",
  "createInSaltDescription": "Create a new team from scratch.",
  "saltLogo": "Salt",
  "importTitle": "Import from Planning Center",
  "importDescription": "Import an existing Planning Center team to quickly get started. Volunteers added after import will not be synced.",
  "planningCenterLogo": "Planning Center",
  "detailsTitle": "New Team",
  "namePlaceholder": "Team Name",
  "nameLabel": "Team name",
  "detailsFootnote": "You can add roles and invite volunteers once the team is created.",
  "create": "Create Team",
  "creating": "Creating...",
  "createFailed": "Unable to create this team right now.",
  "loadTeamsFailed": "Unable to load your Planning Center teams right now.",
  "alreadyImported": "That team has already been imported.",
  "importFailed": "Unable to import this team right now.",
  "importedTitle": "{{team}} was imported",
  "importedVolunteers_one": "{{count}} volunteer",
  "importedVolunteers_other": "{{count}} volunteers",
  "importedRoles_one": "{{count}} role",
  "importedRoles_other": "{{count}} roles",
  "importedSummary": "{{volunteers}} and {{roles}} were added from Planning Center.",
  "unmatched_one": "{{count}} person on this team wasn't added because they aren't in Salt yet. Import your people from Planning Center on the <link>People</link> tab, then invite them to this team.",
  "unmatched_other": "{{count}} people on this team weren't added because they aren't in Salt yet. Import your people from Planning Center on the <link>People</link> tab, then invite them to this team.",
  "goToTeam": "Go to Team",
  "loadingTeams": "Loading your teams from Planning Center…",
  "noTeams": "There are no active teams in your Planning Center account.",
  "createInSaltInstead": "Create a Team in Salt Instead",
  "chooseTeam": "Choose a team to copy into Salt. Its positions become roles, and its people are matched to people already in Salt.",
  "filterPlaceholder": "Filter teams",
  "noFilterMatches": "No teams match that filter.",
  "otherTeams": "Other Teams",
  "imported": "Imported",
  "importFootnote": "A one-time copy: the team won't stay in sync with Planning Center, and no new people are created.",
  "import": "Import Team",
  "importNamed": "Import {{team}}",
  "importing": "Importing…"
}
